var map = {
	"./auth.tsx": 38042,
	"./basicSetting.tsx": 5901,
	"./customerDeliverySetting.tsx": 88085,
	"./customerRegistration.tsx": 96982,
	"./customerSetting.tsx": 54423,
	"./error.tsx": 1672,
	"./masterRegistration.tsx": 15420,
	"./notification.tsx": 25867,
	"./pdfRegistration.tsx": 45201,
	"./pluginManagement.tsx": 93147,
	"./profitMarginSetting.tsx": 39268,
	"./quotation.tsx": 89920,
	"./taxExchangeSettingPage.tsx": 86080,
	"./userRegistrationChange.tsx": 66309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93319;